import React from 'react';
import PropTypes from 'prop-types';
import { withCoreComponent, withModalActions, withModalData } from 'core/hocs';
import { SetupSms2fa as SetupSms2faCore, FormattedTag } from 'core/components';
import { FORM_ACTIONS } from 'core/constants';
import { ButtonWithLoader } from 'components/button-with-loader/button-with-loader';
import { MODAL_IDS } from 'src/constants';

import './setup-sms-2fa.scss';

const options = [
  {
    translationId: 'setup-2fa-sms.description.1',
    tag: '2fa'
  },
  {
    translationId: 'setup-2fa-sms.description.2',
    tag: 'phone'
  },
  {
    translationId: 'setup-2fa-sms.description.3',
    tag: 'one-time-password'
  },
];

const SetupSms2faUI = ({
  setupSms2fa,
  openModal,
  closeModal,
  isPhoneConfirmed,
  currentModal,
}) => {
  const action = currentModal?.data?.action;
  const onContinueWithdrawal = currentModal?.data?.onContinueWithdrawal;
  const isContinueWithdrawalButtonShown = action === FORM_ACTIONS.PROCESS_WITHDRAWAL;

  function onClick() {
    closeModal(MODAL_IDS.SETUP_SMS_2FA);

    if (isPhoneConfirmed) {
      setupSms2fa();
    } else {
      openModal(MODAL_IDS.PROVIDE_MOBILE_PHONE);
    }
  }

  function onContinueWithdrawalClick() {
    closeModal(MODAL_IDS.SETUP_SMS_2FA);

    if (onContinueWithdrawal) {
      onContinueWithdrawal();
    }
  }

  const targetOptions = options.filter((option) => {
    if (isPhoneConfirmed) {
      return option.tag !== 'phone';
    }

    return option;
  });

  return (
    <div
      className="setup-sms-2fa"
    >
      <FormattedTag
        tag="div"
        id="setup-2fa-sms.title"
        className="h2 text-gray-white text-center"
      />

      <div
        className="setup-sms-2fa-content d-flex flex-column my-3"
      >
        {targetOptions
          .map((option, idx) => (
            <span className="h4 font-weight-normal text-white-65">
              {idx + 1}.{' '}
              <FormattedTag
                tag="span"
                id={option.translationId}
                className="h4 font-weight-normal text-white-65"
                isHtml
              />
            </span>
          ))}
      </div>

      <div
        className="setup-sms-2fa-content d-flex flex-column"
      >
        <FormattedTag
          tag={ButtonWithLoader}
          id="confirm"
          isLoading={false}
          color="primary"
          size="lg"
          className="w-100"
          onClick={onClick}
        />

        {isContinueWithdrawalButtonShown && (
          <FormattedTag
            tag={ButtonWithLoader}
            id="setup-2fa-sms.btn.continue-withdrawal"
            isLoading={false}
            color="primary"
            size="lg"
            className="w-100"
            onClick={onContinueWithdrawalClick}
          />
        )}
      </div>
    </div>
  );
};

SetupSms2faUI.propTypes = {
  setupSms2fa: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  isPhoneConfirmed: PropTypes.bool,
  currentModal: PropTypes.shape({
    id: PropTypes.string,
    data: PropTypes.any
  }).isRequired,
};

SetupSms2faUI.defaultProps = {
  isPhoneConfirmed: false,
};

export const SetupSms2Fa = withCoreComponent(SetupSms2faCore,
  withModalData(
    withModalActions(
      SetupSms2faUI
    )
  ));
